import { Dispatch, SetStateAction, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'

import { Button } from 'primsell-shared-layer/components'
import { StripeActions } from 'features'

import { StyledAgreedForm } from './checkout-form.styles'
import { StyledTypography, StyledLink } from 'primsell-shared-layer/components/molecules/agreed-form/agreed-form.styles'

interface ICheckoutFormProps {
  setAgreeCheck: Dispatch<SetStateAction<boolean>>
  agreeCheck: boolean
}
const CheckoutForm = ({ setAgreeCheck, agreeCheck }: ICheckoutFormProps): JSX.Element => {
  const dispatch = useDispatch()
  const stripe = useStripe()
  const elements = useElements()

  const handleSubmit = useCallback(() => {
    if (!stripe || !elements) return
    dispatch(StripeActions.confirmPaymentRequest({ stripe, elements }))
  }, [stripe, elements, dispatch])

  return (
    <>
      <PaymentElement id="payment-element" />
      <StyledAgreedForm
        onChange={(e) => setAgreeCheck(e.target.checked)}
        checked={agreeCheck}
        contentText={
          <StyledTypography color="grey">
            By clicking <strong>Pay</strong> you agree to{' '}
            <StyledLink to={'https://docs.google.com/document/d/17LurkxjfJsh5yIjKbolm5d93kIVW67wDVlqYAf-1eg8'}>
              Terms and Conditions
            </StyledLink>
            {', '}
            <StyledLink to={'https://docs.google.com/document/d/1Y8Xbe-lzIAc1ohWgwGOddU2rFFcv96DnoaMrF29PG3U'}>
              Privacy policy
            </StyledLink>
          </StyledTypography>
        }
      />
      <Button
        variant="filled"
        color="dark"
        fullWidth
        onClick={handleSubmit}
        disabled={!stripe || !elements || !agreeCheck}
      >
        Pay
      </Button>
    </>
  )
}

export { CheckoutForm }
